import React, { useState, useEffect } from 'react';


import '../../App.css';
import Select, { components } from 'react-select';
import { collection, addDoc, getDocs, Timestamp, doc, updateDoc, where, deleteDoc, query, getDoc, } from "firebase/firestore";
import { useLocation, useNavigate } from 'react-router-dom';
import { auth, db } from './../../firebaseConfig';
import TalentCalendar from '../TalentCalendar';
import closeButton from '../../images/close.svg'
import calendarIcon from '../../images/calendar.svg'
import selectIcon from '../../images/select.svg'
import { yearsToMonths } from 'date-fns';
function CreateDummyOrder() {
  const [skipEffect, setSkipEffect] = useState(false);
  const navigate = useNavigate();
  const [similarBookings, setSimilarBookings] = useState([]);
  const [search, setSearch] = useState(""); // New state for search term
  const [sortOrder, setSortOrder] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [talents, setTalents] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedTalentdet, setSelectedTalentdet] = useState(null);
  const [selectedTalent, setSelectedTalent] = useState(null);
  const [selectedTalentName, setSelectedTalentName] = useState(null);
  const [selectedTalentEmail, setSelectedTalentEmail] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [status, setStatus] = useState('');
  const [bookingDetails, setBookingDetails] = useState(null);
  const [selectedCostCenter, setSelecedCostcenter] = useState(null);
  const [selectedCostCentertwo, setSelecedCostcentertwo] = useState(null);
  const [editingbokkingTalentid, setEditingbookingTalentid] = useState('');
  const [editingbookingCompany, setEditingbookingcompany] = useState('');
  const [loading, setLoading] = useState(true);
  const [kpi, setKpi] = useState('KPI');
  const [set, setSet] = useState('SET');
  const [position, setPosition] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [selectedFunction, setSelectedFunction] = useState();
  const location = useLocation();
  const bookingId = new URLSearchParams(location.search).get('bookingId');
  const [groupID, setGroupID] = useState(new URLSearchParams(location.search).get('group'));
  const [times, setTimes] = useState('');
  const [groupColor, setgroupColor] = useState('');
  const [client, setClient] = useState('SetCast- 1. Option');
  const [bookingoption, setbookingoption] = useState();
  const [startTime, setStartTime]= useState();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState(new URLSearchParams(location.search).get('sonstige'));
  const [endTime, setEndTime]= useState();
  const [locations, setLocations] = useState([]);
  const [selectLocations, setSelectedLocations] = useState([]);
  const [segment, setSegment] = useState(new URLSearchParams(location.search).get('segment'));
  const [range, setRange] = useState(new URLSearchParams(location.search).get('range'));
  const positions = [
    { value: 'HM', label: 'Hair & Make-Up' },
    { value: 'AD', label: 'Art Direktion' },
    { value: 'Foto', label: 'Foto' },
    { value: 'foto-assistent', label: 'Foto Assist' },
    { value: 'video', label: 'Video' },
    { value: 'digi-op', label: 'Digi-OP' },
    { value: 'styling', label: 'Styling' },
    { value: 'styling-assistent', label: 'Styling Assist' },
    { value: "LOGISTIK / WARENAUFBEREITUNG", label: "LOGISTIK / WARENAUFBEREITUNG" },
    { value: "PRODUCER", label: "PRODUCER" },
    { value: "Art Buying", label: "Art Buying" }, 
    { value: "Account Management", label: "Account Management" }, 
    
  ];
  const onmodel = [

    { value: 'onmodel', label: 'on Model' },
    { value: 'Produkt', label: 'on Produkt' },

  
  
    ];

  const bookingoptions = [


    { value: '1. Option ', label: '1. Option ' },
    { value: '2. Option ', label: '2. Option ' },

  
  
    ];

    const [selectedOption, setSelectedOption] = React.useState("neworder");
    const [selectedPosition, setselectedPosition] = React.useState(null);
    const handleOptionChange = selectedOption => {
  
      setSelectedOption(selectedOption);
    }
  
    const handlebookingOption = selectedOption => {
  
      setbookingoption(selectedOption);
    }
  
  
    const handlePostionchange = selectedPosition => {
  
      setselectedPosition(selectedPosition);
    }
  
    const handleClientChange = selectedOption => {
  
      setClient(selectedOption);
    }
  
  
    const handlesetSelect = (selectedOption) => {
        setSet(selectedOption);
      };
    const [clientValid, setClientValid] = useState(true);
    const [positionValid, setPositionValid] = useState(true);
    const [optionsValid, setOptionsValid] = useState(true);

  const customStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      border: 'none',
    }),
    control: (base) => ({
      ...base,
      width: '400px',
      borderColor: 'black',
      borderWidth: '1px',
      boxShadow: 'none',
      margin: '5px',
      borderRadius: '0px',
      color: 'black', // Your color
      fontWeight: "700",
      height: '50px',
      textTransform: 'uppercase'
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black', // Your color
      fontWeight: "700"
    }),
    input: (provided) => ({
      ...provided,
      color: 'black', // Your color
      fontWeight: "700",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'black' : 'inherit',
      '&:hover': { backgroundColor: state.isSelected ? 'black' : '#f7f7f7' }
    }),
  };

  const constcenter1 = [
    { id: '714', label: 'Post Outsourcing', accountNumber: '70175', value: '714' },
    { id: '715', label: 'Virtual Production-Operator', accountNumber: '70155', value: '715' },
    { id: '716', label: 'Videograf', accountNumber: '70145', value: '716' },
    { id: '717', label: 'Foto Still', accountNumber: '70110', value: '717' },
    { id: '718', label: 'Styling Still', accountNumber: '70111', value: '718' },
    { id: '719', label: 'Foto Life', accountNumber: '70120', value: '719' },
    { id: '720', label: 'Styling Life', accountNumber: '70121', value: '720' },
    { id: '721', label: 'Foto-Assistenz Life', accountNumber: '70122', value: '721' },
    { id: '722', label: 'Models', accountNumber: '70124', value: '722' },
    { id: '723', label: 'Hair & Make up', accountNumber: '70130', value: '723' },
    { id: '724', label: 'Art Direction', accountNumber: '70160', value: '724' },
    { id: '725', label: 'Post Production', accountNumber: '70170', value: '725' },
    { id: '726', label: 'Text', accountNumber: '70180', value: '726' },
    { id: '727', label: 'Sonstiges Produktion', accountNumber: '70190', value: '727' },
    { id: '728', label: 'Verpflegung Shooting', accountNumber: '70193', value: '728' },
    { id: '729', label: 'Producing', accountNumber: '70230', value: '729' },
    { id: '730', label: 'Modelbooking', accountNumber: '70240', value: '730' },
    { id: '731', label: 'Art Buying', accountNumber: '70250', value: '731' },
    { id: '732', label: 'Logistik/Warenaufbereitung', accountNumber: '70260', value: '732' },
    { id: '733', label: 'Technical Support', accountNumber: '70270', value: '733' },
    { id: '734', label: 'Setbau', accountNumber: '70280', value: '734' },
    { id: '735', label: 'Account Management', accountNumber: '70320', value: '735' },
    { id: '736', label: 'Sales/Marketing', accountNumber: '70440', value: '736' },
    { id: '737', label: 'IT/Technik', accountNumber: '70450', value: '737' },
    { id: '739', label: 'Still Operator', accountNumber: '70115', value: '739' },
    {
      id: "845",
      label: "Digital Operator",
      accountNumber: "70150",
      value: "845",
    },
  ];
  const constcenter2 = [
    { id: '738', label: 'Kunden-übergreifend / Sonstiges', accountNumber: '709005', value: '738' },
    { id: '740', label: 'S.Oliver Produktfoto', accountNumber: '700021', value: '740' },
    { id: '741', label: 'Comma Produktfoto', accountNumber: '700031', value: '741' },
    { id: '742', label: 'Liebeskind Produktfoto', accountNumber: '700041', value: '742' },
    { id: '743', label: 'Görtz Produktfoto', accountNumber: '700051', value: '743' },
    { id: '744', label: 'PUMA Produktfoto', accountNumber: '700061', value: '744' },
    { id: '745', label: 'PUMA Kampagne', accountNumber: '700062', value: '745' },
    { id: '746', label: 'TomTailor Produktfoto', accountNumber: '700071', value: '746' },
    { id: '747', label: 'TomTailor Kamagne', accountNumber: '700072', value: '747' },
    { id: '748', label: 'BonPrix Produktfoto', accountNumber: '700091', value: '748' },
    { id: '749', label: 'HFG Produktfoto', accountNumber: '700101', value: '749' },
    { id: '750', label: 'HFG Kampagne', accountNumber: '700102', value: '750' },
    { id: '751', label: 'Juvia Produktfoto', accountNumber: '700111', value: '751' },
    { id: '752', label: 'HugoBoss Produktfoto', accountNumber: '700121', value: '752' },
    { id: '753', label: 'HugoBoss Kampagne', accountNumber: '700122', value: '753' },
    { id: '754', label: 'Bogner Produktfoto', accountNumber: '700601', value: '754' },
    { id: '755', label: 'Bogner Kampagne', accountNumber: '700602', value: '755' },
    { id: '756', label: 'Heine Produktfoto', accountNumber: '700621', value: '756' },
    { id: '757', label: 'WittWeiden Produktfoto', accountNumber: '705071', value: '757' },
    { id: '758', label: 'Zalando EPS Produktfoto', accountNumber: '705141', value: '758' },
    { id: '759', label: 'Zalando EPS Kampagne', accountNumber: '705142', value: '759' },
    { id: '760', label: 'ToryBurch Produktfoto', accountNumber: '705171', value: '760' },
    { id: '761', label: 'Falke Produktfoto', accountNumber: '705181', value: '761' },
    { id: '762', label: 'Zalando RPDP Produktfoto', accountNumber: '705221', value: '762' },
    { id: '763', label: 'Sonstige Kleinkunden Produktfoto', accountNumber: '707991', value: '763' },
    { id: '766', label: 'PUMA Virtual Production', accountNumber: '700066', value: '766' },
    { id: '767', label: 'C&A Produktfoto', accountNumber: '703421', value: '767' },
    { id: '768', label: 'C&A Kampagne', accountNumber: '703422', value: '768' },
    { id: '769', label: 'C&A Virtual Production', accountNumber: '703429', value: '769' },
    { id: '773', label: 'Ziener Produktfoto', accountNumber: '705051', value: '773' },
    { id: '772', label: 'Zalando EPDP Produktfoto HH', accountNumber: '705191', value: '772' },
    {
      id: "778",
      label: "Tommy Hilfiger Produktfoto",
      accountNumber: "740411",
      value: "778",
    },
  ];
  const handleSelectCostCenter = (selectedOption) => {
    setSelecedCostcenter(selectedOption);
  };
  const handleSelectCostCentertwo = (selectedOption) => {
    setSelecedCostcentertwo(selectedOption);
  };
  const DropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: '16px', margin: '0' }}>
            <svg version="1.1" id="Isolationsmodus" x="0px" y="0px" viewBox="0 0 322.9 257.78" shapeRendering="geometricPrecision">
              <path xmlns="http://www.w3.org/2000/svg" d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z" />
            </svg>
          </div>
        </components.DropdownIndicator>
      )
    );
  };
  const DropdownIndicator2 = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: '16px', margin: '0' }}>
            <svg version="1.1" id="Isolationsmodus" x="0px" y="0px" viewBox="0 0 322.9 257.78" shapeRendering="geometricPrecision">
              <path xmlns="http://www.w3.org/2000/svg" d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z" />
            </svg>
          </div>
        </components.DropdownIndicator>
      )
    );
  };
  const fetchlocations = async () => {
    const locationSnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/locations"));  
    const locationData = locationSnap.docs.map(doc => doc.data().short); 
    setLocations(locationData);
  };
  const locationOptions = locations.map(locations => ({
    value: locations,
    label: locations
  })).sort((a, b) => a.label.localeCompare(b.label));
  useEffect(() => {
    // Fetch companies and talents
    const fetchCompaniesAndTalents = async () => {
      const companySnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/company"));
      const talentSnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talents_new_data"));
      const companyData = companySnap.docs.map(doc => ({
        value: doc.id,
        label: doc.data().name  // assumes the company document has a 'name' field
      }));
      const talentData = talentSnap.docs.map(doc => ({
        value: doc.id,
        Name: doc.data().Name,  // assumes the talent document has a 'name' field
        E_Mail: doc.data().E_Mail,
        Funktion: doc.data().Funktion,
        Tagessatz: doc.data().Tagessatz,
        Bereich: doc.data().Bereich,
        goodPerformanceCompany: doc.data().goodPerformanceCompany,
        badPerformanceCompany: doc.data().badPerformanceCompany,
      }));
      const fetchTalentDetails = async (talentId) => {
        const talentRef = doc(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talents_new_data", talentId);
        const talentSnap = await getDoc(talentRef);
        return talentSnap.exists() ? talentSnap.data() : null;
      };
      setCompanies(companyData);
      setTalents(talentData);
      // If bookingId is present, fetch the booking details
      // If bookingId is present, fetch the booking details

      setLoading(false);
    };
    fetchCompaniesAndTalents();
    fetchlocations();


  }, []);
  const handleTalentChange = (selectedOption) => {
    setSelectedTalent(selectedOption);
  };


  const [samegroupbooking, setSamegroupbooking] = useState([]);


  const handleSubmit = async (e) => {
    setSkipEffect(true);
    e.preventDefault();

    try {
        const newBookingStartDate = new Date(startDate);
        const newBookingEndDate = new Date(endDate);
        const currentDateTime = new Date();

        // Loop over each date from start to end
        for (let dt = new Date(newBookingStartDate); dt <= newBookingEndDate; dt.setDate(dt.getDate() + 1)) {
            const singleDayDate = new Date(dt);
            const newBooking = {
                // companyID: `/company/AmkMAPHQL4TFA9BNicw3`,

                start_date: Timestamp.fromDate(singleDayDate),
                end_date: Timestamp.fromDate(singleDayDate),
                status: 'talentOnHold',
                position: selectedPosition,
                client: { value: client, label: client },
                option: bookingoption.value,
                createdBy: localStorage.getItem("userEmail"),
                proposedBy: localStorage.getItem("userEmail"),
                processingBy: localStorage.getItem("userEmail"),
                createdAt: Timestamp.fromDate(currentDateTime),
                startTime: startTime,
                endTime: endTime,
                talentId: selectedTalent,
                itsDummy: true,
            };

            // Add the new booking to the database
            const docRef = await addDoc(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/Bookings"), newBooking);

            // Add a notification
            await addDoc(collection(db, "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/notifications"), {
                userId: selectedTalentEmail,
                message: `You have been booked for a new job`,
                read: false,
                url: 'talent/my-invitations',
                bookingId: docRef.id, // Link the booking ID
                createdAt: Timestamp.now()
            });
        }

        alert("All bookings and notifications have been created successfully!");
        window.location.reload(); // Reload the page to reflect changes or reset state
    } catch (error) {
        console.error("Failed to create bookings:", error);
        alert("Failed to create bookings. Please try again.");
    }
};


  const sortByName = () => {
    setTalents([...talents].sort((a, b) => {
      return sortOrder ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
    }));
    setSortOrder(!sortOrder);  // Switch the sort order for the next click
  };
  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
  }
  const handleFunctionChange = (e) => {
    setSelectedFunction(e.target.value);
  }
  useEffect(() => {
    if (startDate === "") {
      document.getElementById("start-date");
    }
    if (endDate === "") {
      document.getElementById("end-date");
    }
  }, [startDate, endDate]);
  const uniqueFunctions = [...new Set(talents.map(talent => talent.Funktion))];
  const functionOptions = uniqueFunctions.map(func => ({
    value: func,
    label: func
  }));
  const uniqueTypes = [...new Set(talents.map(talent => talent.Bereich))];
  const typeOptions = uniqueTypes.map(type => ({
    value: type,
    label: type
  }));


  return (
    <div>
      <div className='content-wrapper'>
      <div>
        <div style={{ maxWidth: '500px', marginBottom: '50px' }}>


      <input className='inputtext' type="text" value={client} onChange={(e) => setClient(e.target.value)} required placeholder='SetCast- 1. Option'/>


            <Select
            components={{ DropdownIndicator }}
            options={positions}
            onChange={handlePostionchange}
            placeholder="Position"
            value={selectedPosition}
            styles={customStyles}
            />


        
<Select
                  
                  value={selectLocations}
                  onChange={setSelectedLocations}
                  options={locationOptions}
                  isClearable
                  placeholder="Locations"
                  styles={customStyles}
                />
            <input className='inputtext' type="text" value={description} onChange={(e) => setDescription(e.target.value)} required placeholder='Sonstige Info'/>
           

            <input className='inputtext' type="text" value={startTime} onChange={(e) => setStartTime(e.target.value)} required placeholder='Start Time'/>
            <input className='inputtext' type="text" value={endTime} onChange={(e) => setEndTime(e.target.value)} required placeholder='End Time'/>
        

          <div style={{ display: 'flex' }}>
            <div className="date-input-wrapper">
              <input className='inputdate' id="start-date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} required />
              <svg className="custom-icon" viewBox="0 0 500 500" >
                <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
              </svg>
            </div>

            <div className="date-input-wrapper">
              <input className='inputdate' id="end-date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} required placeholder='END' />
              <svg className="custom-icon" viewBox="0 0 500 500" >
                <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
              </svg>
            </div>
          </div>

      
          <Select
                components={{ DropdownIndicator }}
                options={bookingoptions}
                onChange={handlebookingOption}
                placeholder="Option"
                value={bookingoption}
                styles={customStyles}
                />
    
    {!optionsValid && <p className="error-message">Option is required.</p>}
    </div>




              {similarBookings.length === 0 ?
                <div></div>
                :


                <div className='task-info'>
                  <h3 style={{ marginBottom: '10px' }}>Similar reserved talent</h3>
                  {similarBookings.map(booking => (
                    <div style={{ fontSize: '1.2rem', lineHeight: '1.5' }} key={booking.id}>
                      {booking.client.label} - {booking.position.label} - {booking.talentName} - {booking.talentEmail} - {booking.start_date.toDate().toLocaleDateString().split('T')[0]}  {booking.startTime}- {booking.endTime}
                      <button style={{ marginLeft: '20px' }} className='button' >choose talent</button>
                    </div>
                  ))}
                </div>
              }
              <div className='content-wrapper'>
                <h2 style={{ marginTop: '80px', marginBottom: '20px' }}>select talent</h2>
                <div className='propose-selectors' style={{ display: 'flex', gap: '10px' }}>
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className='inputtext search'
                  />
                  <Select
                    value={typeOptions.find(option => option.value === selectedType)}
                    onChange={option => setSelectedType(option ? option.value : '')}
                    options={typeOptions}
                    isClearable
                    placeholder="Select Type"
                    styles={customStyles}
                  />
                  <Select
                    value={functionOptions.find(option => option.value === selectedFunction)}
                    onChange={option => setSelectedFunction(option ? option.value : '')}
                    options={functionOptions}
                    isClearable
                    placeholder="Select Function"
                    styles={customStyles}
                  />
                </div>
              </div>
            </div>
            {selectedTalent === null ? (
              <div className='content-wrapper content-wrapper-talent-list'>
                <div style={{ maxWidth: '100%', marginTop: '40px' }}>
                  <div className='propose-item-header' style={{ maxWidth: '100%',  }}>
                    <div style={{ flexBasis: '300px' }}>name</div>
                    <div style={{ flexBasis: '200px' }}>function</div>
                    <div style={{ flexBasis: '200px' }}>type</div>
                    <div style={{ flexBasis: '200px' }}>rate</div>
                    <div style={{ flexBasis: '300px' }}> good Performer</div>
                    <div style={{ flexBasis: '300px' }}>bad Performer</div>
                    <div style={{ flexBasis: '80px' }}></div>
                  </div>
                  <div className='propose-list'>

                    {talents.sort((a, b) => {


                      const aMatches = a.goodPerformanceCompany && a.goodPerformanceCompany.some(company => company.label.toLowerCase() === editingbookingCompany.toLowerCase());
                      const bMatches = b.goodPerformanceCompany && b.goodPerformanceCompany.some(company => company.label.toLowerCase() === editingbookingCompany.toLowerCase());



                      if (aMatches && !bMatches) {

                        return -1;
                      }
                      if (!aMatches && bMatches) {

                        return 1;
                      }
                      return 0;
                    }).filter((talent) => {
                      const searchLowerCase = search?.toLowerCase();

                      return (
                        (selectedType ? talent.Bereich === selectedType : true) &&
                        (selectedFunction ? talent.Funktion === selectedFunction : true) &&
                        (
                          String(talent.Name)?.toLowerCase().includes(searchLowerCase) ||
                          String(talent.Funktion)?.toLowerCase().includes(searchLowerCase) ||
                          String(talent.E_Mail)?.toLowerCase().includes(searchLowerCase) ||
                          String(talent.Gage)?.toLowerCase().includes(searchLowerCase) ||
                          String(talent.Notiz_Setcast)?.toLowerCase().includes(searchLowerCase) ||
                          String(talent.Tagessatz)?.toLowerCase().includes(searchLowerCase) ||
                          String(talent.Telefon)?.toLowerCase().includes(searchLowerCase) ||
                          String(talent.Verifizierung)?.toLowerCase().includes(searchLowerCase) ||
                          String(talent.Bereich)?.toLowerCase().includes(searchLowerCase)
                        )
                      );
                    })

                      .map((talent) => (

                        <div>
                          <div key={talent.value}>
                            <div className='propose-item'>
                              <div style={{ flexBasis: '300px' }}>{talent.Name}</div>
                              <div style={{ flexBasis: '200px' }}>{talent.Funktion}</div>
                              <div style={{ flexBasis: '200px' }}>{talent.Bereich}</div>
                              <div style={{ flexBasis: '200px' }}>{talent.Tagessatz}</div>
                              <div style={{ flexBasis: '300px' }}>
                                {talent.goodPerformanceCompany && Array.isArray(talent.goodPerformanceCompany)
                                  ? talent.goodPerformanceCompany.map(company => company.label).join(', ')
                                  : ''}
                              </div>
                              <div style={{ flexBasis: '300px' ,color:'red' }}>
                                {talent.badPerformanceCompany && Array.isArray(talent.badPerformanceCompany)
                                  ? talent.badPerformanceCompany.map(company => company.label).join(', ')
                                  : ''}
                              </div>



                              <div style={{ flexBasis: '80px' }}>
                                <span style={{ marginRight: '20px' }}>
                                  {selectedTalentdet === talent.value ? (
                                    <button className='edit-button' onClick={() => setSelectedTalentdet(null)}>
                                      <img src={closeButton} alt="Close" className="edit-container" />
                                    </button>
                                  ) : (
                                    <button className='edit-button' onClick={() => { setSelectedTalentdet(talent.value); }}>
                                      <img src={calendarIcon} alt="Calendar" className="edit-container" />
                                    </button>
                                  )}
                                </span>
                                <button className='edit-button' onClick={() => { setSelectedTalent(talent.value); setSelectedTalentName(talent.Name); setSelectedTalentEmail(talent.E_Mail); }}>
                                  <img src={selectIcon} alt="Select" className="edit-container" />
                                </button>
                              </div>
                            </div>
                          </div>
                          {selectedTalentdet === talent.value && (
                            <div className='calendar' style={{ marginLeft: '20px', marginRight: '20px' }}>
                              <TalentCalendar talentId={talent.value} initialDate={startDate} />
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className='content-wrapper'>
                  <div style={{ fontWeight: '700', fontSize: '2rem', marginTop: '20px', marginBottom: '20px' }}>
                    <div style={{ fontWeight: '300', fontSize: '1rem', marginBottom: '5px' }}>Selected Talent</div>
                    {selectedTalentName}
                  </div>
                </div>
                <div className='content-wrapper'>
                    <button className='big-button' onClick={handleSubmit}>{'Create Dummy Order'}</button>  <button className='big-button' onClick={() => { setSelectedTalent(null); }}>Clear</button>
                </div>
              </>
            )}
      
       
      </div>
    </div>
  );
            }
export default CreateDummyOrder;